import { array, number, object, string } from "yup";

export const updateTransactionValidation = object({
  customer_id: string().required("Required"),
  tax: string().required("Required"),
  invoice_date: string().required("Required"),
  customer: object({
    billing_address: object({
      state: string().required(),
      zipcode: string().required(),
    }),
    company_name: string().required(),
  }),
  invoice_items: array()
    .of(
      object({
        amount: number().required("Required"),
        description: string().required("Required"),
        quantity: string().required("Required"),
        rate: number().required("Required"),
        uuid: string().optional(),
      })
    )
    .min(1, "At least one invoice item is required"),
});
